
    import '/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-request/basic.md?watch=parent';
    export const toc = [{"id":"zh-cn","depth":2,"title":"zh-CN"},{"id":"en-us","depth":2,"title":"en-US"}];
export const frontmatter = {"title":"Basic","toc":"menu","filename":"docs/x-sdk/demos/x-request/basic.md","lastUpdated":1764914467000,"description":"基础请求示例，展示 XRequest 基本用法。"};